import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, bonusesTotalValue } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-17" data-mp="pj6ds81asqsl">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-18" data-mp="avv3sakrleul">
        <header className="mx-auto max-w-4xl text-center" data-id="element-19" data-mp="at8tw4aein97">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-3 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-20" data-mp="fsv7ieu565ij">
            <GiftIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-21" data-mp="5wi5mtog0lcp" />
            6 Bonus — Valore totale {bonusesTotalValue}
          </h2>
          <p className="mt-4 text-sm font-extrabold uppercase tracking-widest text-blue-600" data-id="element-22" data-mp="3o3pu84osk4yi">
            Oggi inclusi gratuitamente con il tuo Atlante
          </p>
        </header>

        <ul className="mx-auto mt-12 max-w-3xl divide-y divide-blue-100 overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-blue-100" data-id="element-23" data-mp="1mb1l5epgunat">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="flex items-start gap-5 px-5 py-5 md:px-7" data-id="element-24" data-mp="3id52l0pfut85" data-mpi={index}>
              <span className="mt-0.5 text-2xl font-extrabold tracking-tight text-blue-200" data-id="element-25" data-mp="3deaf3lgj0ghp">
                0{index + 1}
              </span>
              <div className="min-w-0 flex-1" data-id="element-26" data-mp="3r8kuhc6muyb3">
                <h3 className="text-lg font-extrabold tracking-tight text-slate-900" data-id="element-27" data-mp="3n67p4ovst2eu">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-blue-900/75" data-id="element-28" data-mp="2zhogu9cr0pmr">{bonus.benefit}</p>
              </div>
              <div className="shrink-0 text-right" data-id="element-29" data-mp="2uibvxu5ftsmt">
                <span className="block whitespace-nowrap text-sm text-blue-900/45" data-id="element-30" data-mp="38gs31m77pl5h">
                  Valore <span className="line-through" data-id="element-31" data-mp="33hfhr5vzom50">{bonus.value}</span>
                </span>
                <span className="mt-1 inline-block rounded-lg bg-emerald-50 px-2.5 py-1 text-xs font-extrabold uppercase tracking-wide text-emerald-600" data-id="element-32" data-mp="nprk1895ipl5">
                  Gratis
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}